/* Arquivo que retorna BackendURL */
/* Criado por Carlos Eduardo em 14/01/2019 */
/* Em caso de dúvidas: contato.carlos@outlook.com */

import Config from '../config';

export default function Backend(url) {
  return `${Config('BackendURL')}${url}`;
}
